import {
  animate,
  keyframes,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { PermissionsService } from '../../../services/permissions.service';
import { UserService } from '../../../services/user.service';
import { BreakpointObserver } from '@angular/cdk/layout';

export interface SideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('150ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('150ms', style({ opacity: 0 })),
      ]),
    ]),
    trigger('rotate', [
      transition(':enter', [
        animate(
          '1000ms',
          keyframes([
            style({ transform: 'rotate(0deg)', offset: '0' }),
            style({ transform: 'rotate(2turn)', offset: '1' }),
          ]),
        ),
      ]),
    ]),
  ],
})
export class SidenavComponent implements OnInit {
  public collapsed = true; // Default to Expanded
  public isNavOpen = false; // Navbar collapsed by default
  public navData: any;
  public screenWidth = 0;
  public sidenavHidden: Boolean = false;
  public usuario: any;
  public imgError = false;

  @Output() onToggleSideNav: EventEmitter<SideNavToggle> = new EventEmitter();
  constructor(
    private authSvc: AuthService,
    private pmsSvc: PermissionsService,
    private breakpointObserver: BreakpointObserver,
    router: Router,
  ) {
    // Re-read the user after each navigation so "Faltan datos" clears once the email is saved
    router.events
      .pipe(filter((e) => e instanceof NavigationEnd), takeUntilDestroyed())
      .subscribe(() => this.getUsuario());
  }

  ngOnInit(): void {
    // Initial emit to sync parent
    this.screenWidth = window.innerWidth;
    this.onToggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth
    });

    // Check responsive mode
    this.breakpointObserver
      .observe(['(max-width: 950px)'])
      .subscribe((result) => {
        this.sidenavHidden = result.matches;
        if (this.sidenavHidden) {
          // If switching to mobile, ensure body acts as if sidenav is collapsed (0 width in body logic usually implies mobile or hidden)
          // But here, if hidden, the component logic in template switches to navbar.
          // We might need to tell parent Sidenav is "hidden" or "collapsed" to remove margin.
          // Let's assume if sidenavHidden, we emit collapsed=false (effectively 5rem or 0 depending on body logic).
          // Actually, if mobile, margin should be 0.
        }
      });

    this.getUsuario();
    this.secciones();
  }

  async secciones() {
    this.navData = await this.pmsSvc.getSecciones();
  }

  async getUsuario() {
    this.usuario = await this.pmsSvc.getUsuario();
  }

  get faltanDatos(): boolean {
    return this.pmsSvc.datosFaltantes(this.usuario).length > 0;
  }

  toggleCollapse(): void {
    this.collapsed = !this.collapsed;
    this.onToggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  closeSidenav(): void {
    this.collapsed = false;
    this.onToggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  logout() {
    this.authSvc.logoutUser();
  }
}
